const baseURL = process.env.VUE_APP_URL_BASE;

export const setBaseUrl = (config) => Object.assign(config, { baseURL });
